import React__default, { useState } from 'react';
import _s from 'styled-components';
import useTheme from './useTheme.js';
import Skeleton from './Skeleton.js';

const styled = typeof _s === "object" && "default" in _s ? _s.default : _s;
const Image = ({
  alt,
  borderRadius = 'none',
  height,
  src,
  testID,
  width,
  minHeight,
  minWidth,
  objectFit = 'fill'
}) => {
  const [loading, setLoading] = useState(true);
  const [theme] = useTheme();
  const getBorderRadius = value => {
    if (!value) return undefined;
    return `${theme.borderRadius[value]}px`;
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, loading && /*#__PURE__*/React__default.createElement(Skeleton, {
    borderRadius: borderRadius,
    height: height || minHeight,
    width: width || minWidth
  }), /*#__PURE__*/React__default.createElement(Container, {
    "$loading": loading,
    alt: alt,
    borderRadius: getBorderRadius(borderRadius),
    "data-testid": testID,
    height: height,
    onError: () => setLoading(false),
    onLoad: () => setLoading(false),
    onLoadStart: () => setLoading(true),
    src: src,
    width: width,
    minWidth: minWidth,
    objectFit: objectFit
  }));
};
const Container = styled.img`
  border-radius: ${({
  borderRadius
}) => borderRadius};
  display: ${({
  $loading
}) => $loading ? 'none' : 'initial'};
  object-fit: ${({
  objectFit
}) => objectFit};
`;

export { Image as default };
//# sourceMappingURL=Image.js.map
